export default class TireWarrantyFileInputs {

  private readonly fileInputsWrapper: JQuery;
  private readonly maxNumOfFiles: number;

  constructor(private form) {
    this.fileInputsWrapper = this.form.find('.js-tireWarrantyFileInputsWrapper');
    this.maxNumOfFiles = this.form.find('.js-maxNumOfFiles').val() as number;

    this.bindChange();
    this.setDisableStateOnFileInputs();
  }

  private bindChange(): void {
    $(document).on('tireWarrantyFileAdded tireWarrantyFileRemoved', (): void => {
      this.setDisableStateOnFileInputs();
    });
  }

  private setDisableStateOnFileInputs(): void {
    this.fileInputsWrapper.find('.-empty .js-fileInput').prop('disabled', this.isMaximumFileLimitReached());
  }

  private isMaximumFileLimitReached(): boolean {
    return this.fileInputsWrapper.find('.-filled').length >= this.maxNumOfFiles;
  }

}
